import lodash from 'lodash-es'
import axios from 'axios'
import { SET_MONITORING_HABILITATIONS } from '../mutation-types'
const monitoring = {
  namespaced: true,
  state: {
    isUpdating: false,
    selectedTraineedEmployees: {},
    selectedEmployeesToMandatory: {},
    selectedEmployeesToRecycled: {},
    selectedEmployeesToBeInitialyTrained: {},
    selectedEmployeesToBeScheduleTrained: {},
    isAllEmployeesToMandatorySelected: {},
    isAllEmployeesToBeRecycleSelected: {},
    isAllEmployeesToBeInitialyTrainedSelected: {},
    isAllTraineedEmployeesSelected: {},
    isAllEmployeesToScheduleSelected: {},
    habilitations: [],
    pagination: {},
    limit: 15,
  },
  mutations: {
    [SET_MONITORING_HABILITATIONS](state, data) {
      state.habilitations = data.data
    },
  },
  actions: {
    downloadHabilitationStatistics({ commit, rootState }, data) {
      return axios
        .get(rootState.appURL + 'statistics', {
          params: data,
        })
        .then((response) => {
          if (lodash.get(response, 'data.data', false)) {
            let data = response.data.data
            return data
          } else {
            throw new Error('Impossible de récupérer la liste des stagaires')
          }
        })
    },
    deleteInscription({ rootState }, data) {
      return axios
        .delete(rootState.apiBaseURL + '/registrations', {
          data,
        })
        .then((response) => {
          if (lodash.get(response, 'data', false)) {
            let data = response.data
            return data
          } else {
            throw new Error('Impossible de récupérer la liste des stagaires')
          }
        })
    },
    getTraineesInfo({ commit, rootState }, data = []) {
      return axios
        .post(rootState.apiBaseURL + '/trainees-order-payload', data)
        .then((response) => {
          if (lodash.get(response, 'data', false)) {
            let data = response.data
            return data
          } else {
            throw new Error('Impossible de récupérer la liste des stagaires')
          }
        })
    },
    getTrainees({ commit, rootState }, params = {}) {
      params.companyId = lodash.get(rootState, 'company.id', null)
      params.establishmentId = lodash.get(rootState, 'establishment.id', null)
      return axios
        .get(rootState.apiBaseURL + '/client-trainees/' + rootState.user.id, {
          params,
        })
        .then((response) => {
          if (lodash.get(response, 'data.data', false)) {
            let data = response.data.data
            return data
          } else {
            throw new Error('Impossible de récupérer la liste des stagaires')
          }
        })
    },
    getInitialCourses({ commit, state, rootState }, params = {}) {
      return new Promise((resolve, reject) => {
        axios
          .post(rootState.apiBaseURL + '/initial-courses', params)
          .then((response) => {
            let resp = []
            if (lodash.get(response, 'data.data')) {
              resp = response.data.data
            }
            resolve(resp)
          })
          .catch((error) => {
            console.log(error)
            reject(error)
          })
      })
    },
    updateTraineeMandatory({ commit, state, rootState }, params = {}) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            rootState.apiBaseURL + '/trainee-habilitation-mandatory',
            params
          )
          .then((response) => {
            if (response) {
              resolve(response)
            }
          })
          .catch((error) => {
            console.log(error)
            reject(error)
          })
      })
    },
    addNewHabilitation({ commit, state, rootState }, params = {}) {
      params.companyId = lodash.get(rootState, 'company.id', null)
      params.establishmentId = lodash.get(rootState, 'establishment.id', null)
      return new Promise((resolve, reject) => {
        axios
          .post(rootState.apiBaseURL + '/trainee-habilitations', params)
          .then((response) => {
            if (response) {
              resolve(response)
            }
          })
          .catch((error) => {
            console.log(error)
            reject(error)
          })
      })
    },

    getHabilitations({ commit, state, rootState }, params = {}) {
      return axios
        .post(rootState.apiBaseURL + '/monitoring-statistics', params)
        .then((response) => {
          if (lodash.get(response, 'data.data', false)) {
            let data = response.data.data
            commit('SET_MONITORING_HABILITATIONS', { data: data })
            return data
          } else {
            throw new Error(
              'Impossible de récupérer la liste des habilitations'
            )
          }
        })
    },
    getServices({ commit, state, rootState }, params = {}) {
      let data = {
        companyId: lodash.get(rootState, 'company.id', null),
        establishmentId: lodash.get(rootState, 'establishment.id', null),
      }
      return axios
        .post(rootState.apiBaseURL + '/services/' + rootState.user.id, data, {
          params,
        })
        .then((response) => {
          if (lodash.get(response, 'data.data', false)) {
            return (data = response.data.data.services.map((item, index) => {
              return {
                key: response.data.data.slugs[index],
                value: item,
              }
            }))
          } else {
            throw new Error('Impossible de récupérer la liste des services')
          }
        })
    },
    getHabilitationBySegment({ commit, state, rootState }, params = {}) {
      return axios
        .post(rootState.apiBaseURL + '/monitoring/' + rootState.user.id, params)
        .then((response) => {
          if (lodash.get(response, 'data.data', false)) {
            return response.data.data
          } else {
            throw new Error(
              'Impossible de récupérer la liste des habilitations'
            )
          }
        })
    },
    getRecyleCourses({ commit, state, rootState }, params = {}) {
      return new Promise((resolve, reject) => {
        axios
          .post(rootState.apiBaseURL + '/recycle-courses', params)
          .then((response) => {
            let resp = []
            if (lodash.get(response, 'data.data')) {
              resp = response.data.data
            }
            resolve(resp)
          })
          .catch((error) => {
            console.log(error)
            reject(error)
          })
      })
    },
  },
  getters: {},
}
export default monitoring
